import React from 'react';
import { CommonCalendar } from '../../Components/Common/Calendar';
import i18n from 'i18n-js';
import moment from 'moment';

const selectDate = (func: any, val: string, type: string) => {
  func(val, type)
}

const Calendar = (props: any) => {
  return (
    <div className="box-calendar-legend">
      {
        // <p className="title">{i18n.t('haveTime')}</p>
      }
      <CommonCalendar
        userDataCalendar={props.userCalendar}
        getUserCalendar={props.getUserCalendar}
        selectDate={(val: string) => {
          if (!props.bookingInfoCalcDataLoading) {
            if (props.solutionsSpecial && (!props.currentUser || props.dogsList.length)) {
              selectDate(props.selectDate, val, 'bookingSpecialType')
            } else if (!props.dateFrom && props.dateTo) {
              if (val < props.dateTo) {
                selectDate(props.selectDate, val, 'from')
                return;
              }


              if (props.solutionsSlug === 'homePrice' && val <= props.dateTo) {
                selectDate(props.selectDate, val, 'from')
                return;
              }

              alert(i18n.t('invalidDateSelected'));
            } else if (props.dateFrom && !props.dateTo) {
              if (props.dateFrom < val) {
                if (moment(props.dateFrom, 'YYYY-MM-DD') < moment(val, 'YYYY-MM-DD')) {
                  selectDate(props.selectDate, val, 'to')
                  return;
                }
              }

              if (props.solutionsSlug === 'homePrice') {
                if (moment(props.dateFrom, 'YYYY-MM-DD') <= moment(val, 'YYYY-MM-DD')) {
                  selectDate(props.selectDate, val, 'to')
                  return;
                }
              }

              alert(i18n.t('invalidDateSelected'));
              return;

            } else if (props.dateFrom && props.dateTo) {
              props.setStateValue({ dateFrom: val, dateTo: null, bookingInfoCalcData: null });
            } else if (!props.dateFrom && !props.dateTo) {
              props.setStateValue({ dateFrom: val, dateTo: null, bookingInfoCalcData: null });
            }
          }
        }}
      />
      <div className="box-legend">
        <span className="available" /><span>{i18n.t('available')}</span> <span className="unavailable" /><span>{i18n.t('notAvailable')}</span> <span className="has-booking" /><span data-toggle="tooltip" title={i18n.t('hotBookingDescription')}>{i18n.t('hotBooking')}</span>
      </div>
    </div>
  )
}

export default Calendar;
